<template>
  <div v-bind="$attrs"
       v-on="$listeners"
       :style="{ ...containerStyle, width: width }">
    <div :style="innerContainerStyle">
      <div :style="headerContainerStyle">
        <slot name="header"
              :header="header">
          {{ header }}
        </slot>
      </div>
      <div v-for="(row, index) in rows" :key="index"
           :style="rowContainerStyle">
        <slot name="row"
              :index="index"
              :row="row">
          {{ row }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseTableColumn',
    inheritAttrs: false,
    props: {
      header: { type: String, required: false, default: '' },
      rows: { type: Array, required: false, default: () => [] },
      truncate: { type: Boolean, required: false, default: false },
      width: { type: String, required: false, default: null },
    },
    data: function () {
      return {
        containerStyle: {
          //height: '100%',
        },
        headerContainerStyle: {
          width: '100%',
        },
        innerContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          height: '100%',
          width: '100%',
        },
        rowContainerStyle: {
          width: '100%',
        },
        truncateStyle: {
          //overflow: 'hidden',
          //textOverflow: 'ellipsis',
          //whiteSpace: 'nowrap',
        },
      };
    },
    created: function () {
      this.containerStyle = {
        ...this.containerStyle,
        ...this.$attrs,
      };

      this.headerContainerStyle = {
        ...this.headerContainerStyle,
        ...(this.truncate ? this.truncateStyle : {}),
        ...this.$attrs.headerContainerStyle,
      };

      this.innerContainerStyle = {
        ...this.innerContainerStyle,
        ...this.$attrs.innerContainerStyle,
      };

      this.rowContainerStyle = {
        ...this.rowContainerStyle,
        ...(this.truncate ? this.truncateStyle : {}),
        ...this.$attrs.rowContainerStyle,
      };
    },
  };
</script>
